import 'date-fns'
import jaLocale from "date-fns/locale/ja"
import format from "date-fns/format"
import styled from 'styled-components'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"
import { push } from "connected-react-router"
// components
import { Layout, PrimaryButton, TextDetail, SelectBox } from "../components"
// mui
import Button from '@material-ui/core/Button'
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
// firebase
import { db, functions } from '../firebase'

const carriers = [
    {id:"yamato",name:"ヤマト運輸"},
    {id:"sagawa",name:"佐川急便"},
    {id:"jp",name:"日本郵便"}
]

class ExtendedUtils extends DateFnsUtils {
    getCalendarHeaderText(date) {
      return format(date, "yyyy MMM", { locale: this.locale });
    }
    getDatePickerHeaderText(date) {
      return format(date, "MMMd日", { locale: this.locale });
    }
}

const dateTimeToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) + ' ' + 
        ('00' + date.getHours()).slice(-2) + ':' + 
        ('00' + date.getMinutes()).slice(-2) + ':' + 
        ('00' + date.getSeconds()).slice(-2)
}

const dateToString = (date) => {
    return date.getFullYear() + '-' + 
        ('00' + (date.getMonth()+1)).slice(-2) + '-' + 
        ('00' + date.getDate()).slice(-2) 
}

const OrderDetail = () => {
    const dispatch = useDispatch()

    // URLからorderIdを取得
    const selector = useSelector(state=>state)
    const path = selector.router.location.pathname
    const orderId = path.split('/order/dp/')[1]

    const [status, setStatus] = useState('')
    const [carrier, setCarrier] = useState('')
    const [trackingId, setTrackingId] = useState('')
    const [orderDate, setOrderDate] = useState('')
    const [shippingDate, setShippingDate] = useState('')
    const [selectedDate, setSelectedDate] = useState(new Date())
    const [amount, setAmount] = useState('')
    const [shippingFee, setShippingFee] = useState('')
    const [user, setUser] = useState('')
    const [products, setProducts] = useState([{
        productId: "", productName: "", price: "", quantity: ""
    }])

    // // 発送処理
    const shipOrder = (userId, orderId, selectedDate, carrier, trackingId) => {
        console.log(shippingDate)
        console.log(selectedDate)
        if (selectedDate === '' || carrier === '' || trackingId === '') {
            alert('未入力の必須項目があります')
            return false
        }
        // お問い合わせ番号Validation
        const regexTel = /^[0-9]{11,13}$/
        if (!regexTel.test(trackingId)) {
            alert('お問い合わせ番号は11〜13桁の数字で入力してください（ハイフン不要）')
            return false
        }

        if (window.confirm("購入者へ発送完了メールを送信します。よろしいですか？")) {
            // Firestore更新処理
            const data = {
                status: '発送完了', 
                shipping_date: selectedDate, 
                carrier, 
                tracking_id: trackingId
            }
            const mailData = {
                to: 'Jeff.S.63mSwHfl@gmail.com',
                subject: '【Weth-Store】商品を発送しました',
                text: `
下記の商品を発送しました。

注文番号：
${orderId}

配送業者：
${carrier}

伝票番号
${trackingId}

返答までいましばらくお待ち下さい。
`
            }
            const sendMail = functions.httpsCallable('sendMail')
            db.collection('users').doc(userId)
              .collection('orders').doc(orderId)
              .set(data, {merge: true})
              .then(()=>{
                    // 発送メール送信処理
                    sendMail(mailData)
                    // 完了メッセージ表示・画面更新・フォームリセット・返信済みに
                    setStatus('発送完了')
                    alert('発送完了メールはまだ送信できませんが、注文のステータスを発送済みに変更しました。')
                    return false
              })
        } else {
            return false
        }
    }

    // 注文データ取得
    useEffect(() => {
        if(orderId) {
            db.collectionGroup('orders').where('id','==',orderId)
              .get()
              .then(snapshots => {
                    snapshots.forEach(snapshot => {
                        const data = snapshot.data()
                        setStatus(data.status)
                        setOrderDate(data.created_at)
                        setShippingDate(data.shipping_date ? data.shipping_date : "")
                        setShippingFee(data.shipping_fee)
                        setAmount(data.amount)
                        setCarrier(data.carrier ? data.carrier : "")
                        setTrackingId(data.tracking_id ? data.tracking_id : "")
                        setProducts(data.products)
                        setUser(data.user)
                    })
              })
        }
    },[orderId])

    return (
        <Layout>
            <div className='spacer-50' />
            <h1 style={{textAlign:'center'}}>注文詳細</h1>

            <div className='spacer-50' />
            <Wrapper>

                <TextDetail label={'ステータス'} value={status} />

                <div className='spacer-50' />

                <TextDetail label={'注文ID'} value={orderId} />
                <TextDetail label={'注文日時'} value={orderDate ? dateTimeToString(orderDate.toDate()) : ""} />
                <TextDetail label={'商品数'} value={products.length} />
                <TextDetail label={'送料'} value={shippingFee} />
                <TextDetail label={'合計金額'} value={amount} />
                <TextDetail label={'お届け先氏名'} value={user.lastname + " " + user.firstname} />
                <TextDetail label={'お届け先住所'} value={"〒" + user.postalCode + " " + user.prefecture + user.city + user.street} />
                <TextDetail label={'発送日'} value={shippingDate ? dateToString(shippingDate.toDate()) : ""} />
                <TextDetail label={'配送業者'} value={carrier} />
                <TextDetail label={'追跡番号'} value={trackingId} />
                <Button onClick={()=>dispatch(push('/admin/customer/dp/' + user.id))}>購入者情報</Button>

                <div className='spacer-50' />
                <SubHeading>商品情報</SubHeading>
                {products && products.map((product,index) => (
                    <Accordion defaultExpanded key={`${product.id}`}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                            <Typography component={'h3'}>商品{index+1}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography>商品名：{product.name}</Typography>
                        </AccordionDetails>
                        <AccordionDetails>
                            <Typography>価格：¥{product.price}</Typography>
                        </AccordionDetails>
                        <AccordionDetails>
                            <Typography>数量：{product.quantity}</Typography>
                        </AccordionDetails>
                    </Accordion>
                ))}
                <div className='spacer-50' />

                {status !== '発送完了' && (
                    <>
                        <SubHeading>発送処理</SubHeading>
                        <MuiPickersUtilsProvider utils={ExtendedUtils} locale={jaLocale}>
                            <DatePicker
                                label="発送日"
                                disableFuture
                                value={selectedDate}
                                onChange={setSelectedDate}
                                animateYearScrolling
                                okLabel="決定" cancelLabel="キャンセル"
                                required={true}
                            />
                        </MuiPickersUtilsProvider>
                        <SelectBox
                            label={'配送業者'} required={true} select={setCarrier} value={carrier} options={carriers} 
                        />
                        <TextField 
                            type={'text'} fullWidth={true} multiline={false} rows={1} label={'追跡番号'} required={true}
                            value={trackingId} onChange={e=>setTrackingId(e.target.value)}
                        />
                        <div className='spacer-50' />
                    </>
                )}
            </Wrapper>

            <div style={{textAlign:'center'}}>
                {status !== '発送完了' && (
                    <>
                        <PrimaryButton label="発送を完了させる" operation={()=>shipOrder(user.id, orderId, selectedDate, carrier, trackingId)} />
                        <div className='spacer-50' />
                    </>
                )}
                <Button onClick={()=>dispatch(push('/admin/order'))}>一覧に戻る</Button>
            </div>

            <div className='spacer-100' />
        </Layout>
    );
};

export default OrderDetail

const Wrapper = styled.div`
    width: 480px;
    margin: 0 auto;
`
const SubHeading = styled.h4`
    font-size: 24px !important;
    margin-bottom: 24px;
`